<div class="grid-container">
    <mat-grid-list cols="4" rowHeight="350px">
        <!-- Single points: Cloud Users / Accounts / App Instances / MRR -->
        @for (card of cards; track card; let i = $index) {
            <mat-grid-tile [colspan]="card.cols" [rowspan]="card.rows" class="mat-grid-tile-title-bold">
                <r1-metrics-single-datapoint [card]="cards[i]" [readAs]="card.title" />
            </mat-grid-tile>
        }
        <!-- Example ngx-chart, waiting for actual story (had time to work on this before the actual story) -->
        <!-- <mat-grid-tile [colspan]="4" [rowspan]="1" class="mat-grid-tile-title-bold">
    <r1-metrics-chart-datapoint></r1-metrics-chart-datapoint>
  </mat-grid-tile> -->
    </mat-grid-list>
</div>
@if (isLoading$ | async) {
    <r1-loading-spinner [loadingMessages]="loadingMessages$ | async" />
}
